module.exports = __webpack_public_path__ + "static/media/assign.d3382ac3.svg";